import { render } from "./mvt-checkemail.vue?vue&type=template&id=0c94113e"
import script from "./mvt-checkemail.js?vue&type=script&lang=js"
export * from "./mvt-checkemail.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__